import bannerImg1 from '../assets/images/placeholder-images/placeholder-image (1).png';
import bannerImg2 from '../assets/images/placeholder-images/placeholder-image (2).png';

/**
 * Demo banners shown on the home page when the store
 * has not added any banners yet.
 */
export const bannerPlaceholder = [
    {
        _id: 'placeholder-banner-1',
        description: {
            en: 'Summer Collection 2026 - Find Your Perfect Style',
            tr: 'Yaz Koleksiyonu 2026 - Mükemmel Tarzınızı Bulun',
            fa: 'مجموعه تابستانی ۲۰۲۶ - استایل عالی خود را پیدا کنید',
            ar: 'مجموعة صيف 2026 - اعثر على أسلوبك المثالي',
            el: 'Καλοκαιρινή Συλλογή 2026 - Βρείτε το Τέλειο Στυλ σας',
            ru: 'Летняя коллекция 2026 — Найдите свой идеальный стиль',
        },
        imageUrl: [bannerImg1, bannerImg2],
        status: 'active',
    },
];
